// extracted by mini-css-extract-plugin
module.exports = {"twoColumnsH4":"styles_twoColumnsH4__GfncW","block":"styles_block__9W8_B","blockH4":"styles_blockH4__x2yQK","blockDescription":"styles_blockDescription__3Akge"};